<template>
    <div class="uzhnet-button-component">
        <div v-if="!selected" @click="selected = true" class="uzhnet-button-container">
            <div class="uzhnet-button-label">{{ selectedValue ? getLabelByValue(selectedValue) : label }}</div>

            <svg width="100%" height="200%" viewBox="0 0 344 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M343 1V32.7284L337.593 38H1V6.27165L6.40682 1H343Z" fill="#C7C8D1" fill-opacity="0.1" stroke="#C7C8D1" stroke-width="1"/>
                <path d="M313 17L319 23L325 17" stroke="#C7C8D1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div v-else @click="selected = false" class="uzhnet-button-container-open">
            <div class="uzhnet-button-label">{{ selectedValue ? getLabelByValue(selectedValue) : label }}</div>
            <svg width="100%" height="200%" viewBox="0 0 344 280" fill="none" stroke-width="2" xmlns="http://www.w3.org/2000/svg">
                <path d="M343.5 0.5V275.601L337.844 279.5H0.5V4.39897L6.15565 0.5H343.5Z" fill="#C7C8D1" fill-opacity="0.1" stroke="#C7C8D1" stroke-width="1"/>
                <path d="M312 17L318 23L324 17" stroke="#C7C8D1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div class="uzhnet-option-group">
                <div
                    v-for="option in options"
                    :key="option.value"
                    class="uzhnet-option"
                    :class="{ 'uzhnet-option-selected': option.value === selectedValue }"
                    @click="selectedValue = option.value"
                >
                    {{ option.label }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref, watch, onMounted } from 'vue';

export default {
    name: "UzhnetMultiSelect",

    setup(props, { emit }) {
        const selected = ref(false);
        const selectedValue = ref('');

        const getLabelByValue = (value) => {
            return props.options.find(option => option.value === value).label;
        }

        watch(selectedValue, (newValue) => {
            emit('update:modelValue', newValue);
        });

        onMounted(() => {
            if (props.modelValue) {
                selectedValue.value = props.modelValue;
            }
        });

        return {
            selected,
            selectedValue,
            getLabelByValue
        }
    },

    props: {
        label: {
            type: String,
            default: 'Ваш текст...'
        },

        fontSize: {
            type: String,
            default: '14px'
        },
        modelValue: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            default: [
                { value: '1', label: 'Option 1' },
                { value: '2', label: 'Option 2' },
                { value: '3', label: 'Option 3' }
            ]
        }
    }
}
</script>
<style lang="scss" scoped>
.uzhnet-button-component {
    position: relative;
    height: max-content;
    z-index: 9999;
}

.uzhnet-button-container {
    position: relative;
    width: 100vw; /* Розтягує контейнер на всю ширину екрана */
    max-width: 100%; /* Гарантує відсутність обмежень */
    margin: 0;
    height: 100%; /* Висота SVG */
}

.uzhnet-option {
    padding: 10px 20px;
    font-size: 14px;
    color: #C7C8D1;
    text-align: end;
}

.uzhnet-option-selected {
    background-color: #E0C522;
    color: #1B1C22;
}

.uzhnet-option-group {
    position: absolute;
    top: 12%;
    left: 0;
    width: 100%;
    z-index: 1;
    overflow-y: auto;
    max-height: 80%;
}

.uzhnet-button-container-open {
    & > .uzhnet-button-label {
        top: 5%;
        transform: none;
    }

}

.uzhnet-button-label {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    width: 100%; /* Розтягує input на всю ширину контейнера */

    border: none;
    background: transparent;
    font-size: v-bind(fontSize);
    color: #C7C8D1;
    text-align: start;
    display: flex;
    justify-content: start;
    align-items: center;
    padding: 0 20px;
}
</style>
